var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockWise(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 6.94163C11.9584 6.88329 11.6667 7.17496 11.6084 7.46663C11.3751 10.0333 9.04174 11.9 6.47507 11.6083C3.9084 11.3166 2.10007 9.09996 2.3334 6.53329C2.56674 3.96663 4.90007 2.09996 7.46674 2.33329C8.69174 2.44996 9.8584 3.09163 10.6167 4.08329H8.75007C8.40007 4.08329 8.16674 4.31663 8.16674 4.66663C8.16674 5.01663 8.40007 5.24996 8.75007 5.24996H11.6667C12.0167 5.24996 12.2501 5.01663 12.2501 4.66663V1.74996C12.2501 1.39996 12.0167 1.16663 11.6667 1.16663C11.3167 1.16663 11.0834 1.39996 11.0834 1.74996V2.85829C8.75007 0.583293 5.07507 0.641626 2.8584 2.97496C0.641736 5.30829 0.641736 8.98329 2.97507 11.2C5.3084 13.4166 8.9834 13.4166 11.2001 11.0833C12.1334 10.15 12.7167 8.92496 12.8334 7.58329C12.8334 7.23329 12.6001 6.99996 12.2501 6.94163C12.3084 6.94163 12.3084 6.94163 12.2501 6.94163Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWise);
export default __webpack_public_path__ + "static/media/ClockWise.1a82a414ef8c00db72e7cc5a1d31f8d3.svg";
export { ForwardRef as ReactComponent };